// extracted by mini-css-extract-plugin
export default {"products":"Wz-z","card":"Xz-z","oosMessaging":"Yz-z"};